import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Lightbox from 'lightbox-react';
import { useImage } from '../../services/Image/useImage';
import useValue from '../../services/Form/useValue';
import Translate from '../common/Translate';
import 'lightbox-react/style.css';

const MultiplePhotos = (props) => {
  const { elementIds, question, setDisableNav, goNextQuestion } = props;
  const { questionId, sectionId, formId } = elementIds;
  const [images, , refreshImages] = useValue(formId, sectionId, questionId, question.type, 'images');
  const [value, setValue] = useValue(formId, sectionId, questionId, question.type, 'value');

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value !== null && value !== '' && value !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const onClick = (option) => {
    if (option === value) setValue(null);
    else setValue(option);
    if (goNextQuestion) goNextQuestion();
  };

  let i = 0;
  return (
    <div className="before-sticky-bottom" data-cy={questionId}>
      {images !== null &&
        images !== undefined &&
        Object.entries(images).map(([key, image]) => {
          i = Number(key);
          if (!image || image.id === null) return null;
          return (
            <ImageItem
              key={i}
              questionId={questionId}
              questionType={question.type}
              sectionId={sectionId}
              formId={formId}
              refreshParent={refreshImages}
              imageNumber={key}
            />
          );
        })}
      <Row>
        <Col xs="4" md="3" lg="3">
          <button
            type="button"
            outline="true"
            color="primary"
            className={`btn btn-block btn-value h-100 ${value === 'finish' && ' selected'}`}
            data-cy="finish"
            onClick={() => onClick('finish')}
          >
            <Translate code="finish" />
          </button>
        </Col>
        <Col xs="8" md="3" lg="3">
          <button type="button" className="btn btn-block btn-value h-100">
            <UpdateImage
              key={i + 1}
              questionId={questionId}
              questionType={question.type}
              sectionId={sectionId}
              formId={formId}
              refreshParent={refreshImages}
              imageNumber={i + 1}
            />
          </button>
        </Col>
      </Row>
    </div>
  );
};

export default MultiplePhotos;

MultiplePhotos.propTypes = {
  elementIds: PropTypes.shape().isRequired,
  setDisableNav: PropTypes.func,
  goNextQuestion: PropTypes.func,
  question: PropTypes.shape().isRequired,
};

MultiplePhotos.defaultProps = {
  setDisableNav: undefined,
  goNextQuestion: undefined,
};

const ImageItem = ({ imageNumber, formId, sectionId, questionId, refreshParent, questionType }) => {
  const pathImage0 = `inspection.children.${sectionId}.children.${questionId}.images.${imageNumber}.id`;
  const [image0, , deleteImage0] = useImage(formId, pathImage0, questionId, questionType);
  const handleDeleteBlock = async () => {
    await deleteImage0();
    refreshParent();
  };
  const [popedUp, setPopup] = useState(false);

  const togglePopup = () => {
    setPopup(!popedUp);
  };

  // in case there is a picture, we display it and delete button
  return (
    <Col xs="12" md="6" lg="6">
      {popedUp && <Lightbox mainSrc={image0} onCloseRequest={togglePopup} />}
      <Row className="single-damage-image">
        <Col xs="10" className="slide-damage-wrapper">
          <div className="damage-image" onClick={() => togglePopup(image0)} onKeyDown={() => {}} role="presentation">
            <img src={image0} alt="" />
          </div>
        </Col>
        <Col xs="2">
          <FontAwesomeIcon
            icon={faTimesCircle}
            onClick={handleDeleteBlock}
            className="damage-delete-btn"
            data-cy={`${imageNumber}_deleteBlock`}
            size="2x"
          />
        </Col>
      </Row>
    </Col>
  );
};

ImageItem.propTypes = {
  imageNumber: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  refreshParent: PropTypes.func.isRequired,
  questionType: PropTypes.string.isRequired,
};

const UpdateImage = ({ imageNumber, formId, sectionId, questionId, refreshParent, questionType }) => {
  const pathImage0 = `inspection.children.${sectionId}.children.${questionId}.images.${imageNumber}.id`;
  const [, setImage0] = useImage(formId, pathImage0, questionId, questionType);

  const handleUploadImage = async (e) => {
    await setImage0(e.target.files[0]);
    refreshParent();
  };

  return (
    <>
      <label htmlFor={`upload_camera_${imageNumber}_element`} className="button-camera circle">
        <FontAwesomeIcon icon={faCamera} />
        <input
          type="file"
          id={`upload_camera_${imageNumber}_element`}
          accept="image/*"
          capture="camera"
          onChange={(e) => handleUploadImage(e)}
          data-cy="add_image_camera"
        />
      </label>
    </>
  );
};

UpdateImage.propTypes = {
  imageNumber: PropTypes.number.isRequired,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  questionId: PropTypes.string.isRequired,
  refreshParent: PropTypes.func.isRequired,
  questionType: PropTypes.string.isRequired,
};
